import React from "react";
import { getTier } from "../sport/tiers";

export default function TierBadge({ sr, className = "" }) {
  const tier = getTier(sr);
  if (!tier) return null;
  return (
    <span
      className={`inline-flex items-center gap-1 text-[10px] font-bold rounded-full px-2 py-0.5 border tabular-nums ${tier.chip} ${className}`}
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-3 h-3"
      >
        <circle cx="12" cy="8" r="6" />
        <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11" />
      </svg>
      {tier.name}
    </span>
  );
}
